// 舆情管理路由
export default {
    path: 'opinion',
    component: () => import('@/components/RouterView'),
    redirect: 'noRedirect',
    meta: {title: '舆情管理'},
    children: [
        {
            path: 'suggest',
            component: () => import('@/components/RouterView'),
            redirect: '/opinion/suggest/list',
            meta: { title: '投诉建议'},
            children: [{
                path: 'list',
                component: () => import('@/views/opinion/suggest/list.vue'),
                meta: {title: '投诉建议列表'}
            }]
        },
        {
            path: 'helpMange',
            component: () => import('@/components/RouterView'),
            redirect: '/opinion/helpMange/list',
            meta: { title: '帮助管理'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/opinion/helpMange/list.vue'),
                    name: 'helpMange-list',
                    meta: {title: '帮助管理列表'}
                },
                {
                    path: 'mangeMenu/:id/:title/:pid?/:parentTitle?',
                    component: () => import('@/views/opinion/helpMange/mangeMenu.vue'),
                    name: 'helpMange-mangeMenu',
                    meta: {title: '词条列表'}
                },
                {
                    path: 'addMangeMenu/:secondMenuId/:title/:firstMenuId?/:parentTitle?',
                    component: () => import('@/views/opinion/helpMange/components/addWord.vue'),
                    name: 'helpMange-add-mangeMenu',
                    meta: {title: '词条创建'}
                },
                {
                    path: 'editMangeMenu/:secondMenuId/:title/:wordId/:firstMenuId?/:parentTitle?',
                    component: () => import('@/views/opinion/helpMange/components/addWord.vue'),
                    name: 'helpMange-edit-mangeMenu',
                    meta: {title: '词条编辑'}
                }
            ]
        },
    ]
}